import React from 'react';
import { useWebSocket } from './WebSocketProvider';
import './UploadProgressBar.css'; // Create this CSS file next

const UploadProgressBar = () => {
  const { uploadProgress } = useWebSocket();

  /*if (!uploadProgress || uploadProgress.totalFiles === 0) {
    return null;
  }*/

  const { totalFiles, successful, duplicates, failed } = uploadProgress;

  const getProgressPercentage = (count) => {
    return totalFiles > 0 ? (count / totalFiles) * 100 : 0;
  };

  const successPercentage = getProgressPercentage(successful);
  const duplicatePercentage = getProgressPercentage(duplicates);
  const failedPercentage = getProgressPercentage(failed);

  return (
    <div className="upload-progress-bar-container">
      <div className="progress-summary">
        <span>Feltöltés</span> {/*}: {successful}/{totalFiles} sikeres</span>
        {duplicates > 0 && <span>, {duplicates} duplikált</span>}
        {failed > 0 && <span>, {failed} hibás</span>}*/}
      </div>

      <div className="individual-progress-bars">
        {totalFiles > 0 && (
          <>
            <div className="progress-bar-item">
              <span className="progress-label">
                <i className="bi bi-check-circle-fill success-icon"></i>
              </span>
              <div className="progress-bar-wrapper">
                <div
                  className="progress-bar-fill success"
                  style={{ width: `${successPercentage}%` }}
                />
                <span className="progress-bar-text">
                  {successful} ({successPercentage.toFixed(0)}%)
                </span>
              </div>
            </div>

            <div className="progress-bar-item">
              <span className="progress-label">
                <i className="bi bi-exclamation-triangle-fill duplicate-icon"></i>
              </span>
              <div className="progress-bar-wrapper">
                <div
                  className="progress-bar-fill duplicate"
                  style={{ width: `${duplicatePercentage}%` }}
                />
                <span className="progress-bar-text">
                  {duplicates} ({duplicatePercentage.toFixed(0)}%)
                </span>
              </div>
            </div>

            <div className="progress-bar-item">
              <span className="progress-label">
                <i className="bi bi-x-circle-fill failed-icon"></i>
              </span>
              <div className="progress-bar-wrapper">
                <div
                  className="progress-bar-fill failed"
                  style={{ width: `${failedPercentage}%` }}
                />
                <span className="progress-bar-text">
                  {failed} ({failedPercentage.toFixed(0)}%)
                </span>
              </div>
            </div>

          </>
        )}
      </div>
    </div>
  );
};

export default UploadProgressBar;
